export default {
  brand: 'AllChinaBuy Spreadsheet',
  nav: {
    home: 'Accueil',
    categories: 'Catégories',
    guide: 'Guide du Spreadsheet',
    guides: 'Guides',
    about: 'À propos',
    sheet: 'AllChinaBuy Sheet',
    faq: 'FAQ',
    collapse: 'Réduire',
    expand: 'Développer',
  },
  lang: {
    label: 'Langue',
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },
  cta: {
    spreadsheet: 'AllChinaBuy Spreadsheet',
    buyNow: 'Acheter maintenant',
    explore: 'Explorer le Spreadsheet',
    browse: 'Parcourir les catégories',
    readGuide: 'Lire le guide',
    backHome: "Retour à l'accueil",
    allCategories: 'Toutes les catégories',
  },
  disclosure:
    "Ce site est une ressource d'information indépendante et n'est ni affilié ni approuvé par AllChinaBuy. Nous pouvons percevoir une commission sur les achats effectués via les liens de ce site.",
  footer: {
    tagline:
      "Votre guide indépendant pour trouver des produits, vérifier leur qualité et acheter plus intelligemment avec le spreadsheet AllChinaBuy.",
    quickLinks: 'Liens rapides',
    categoriesTitle: 'Catégories',
    resources: 'Ressources',
    guide: 'Guide du Spreadsheet',
    safety: 'Sécurité & Transparence',
    copyright: '© 2026 AllChinaBuy Spreadsheet. Tous droits réservés.',
    madeWith: 'Conçu pour des achats plus intelligents.',
  },
};